import { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { getCurrentViewer, setThemingColorForDbIds } from "utils/forge";
import { traverseDbId } from "utils/forge/viewerData";

const useBehaviorOtherObjects = () => {
  const { isLoadedViewer, isLoadedViewerModelData } = useSelector(
    (state: RootState) => state.forgeViewer
  );

  const hideOtherObjectsWithExcludeDbIds = useCallback(
    (excludeDbIds: number[]) => {
      const viewer = getCurrentViewer();
      if (!isLoadedViewer || !viewer?.model) {
        return;
      }

      viewer.clearThemingColors(viewer.model);
      viewer.hideAll();
      const showDbIds = new Set([...excludeDbIds]);
      viewer.show([...showDbIds]);
    },
    [isLoadedViewer]
  );

  const clearHighlightOtherObjects = useCallback(() => {
    const viewer = getCurrentViewer();
    if (!isLoadedViewer || !viewer?.model) {
      return;
    }

    viewer.clearThemingColors(viewer.model);
  }, [isLoadedViewer]);

  const highlightOtherObjectsWithExcludeDbIds = useCallback(
    (params: {
      // highlight objects exclude dbIds
      excludeDbIds: number[];
      color: string;
    }) => {
      const viewer = getCurrentViewer();
      if (!viewer?.model || !isLoadedViewerModelData) {
        return;
      }

      const setExcludeDbIds = new Set([...params.excludeDbIds]);
      const highlightDbIds: number[] = [];
      traverseDbId((dbId) => {
        if (setExcludeDbIds.has(dbId)) {
          return;
        }

        highlightDbIds.push(dbId);
      });

      // Due to the large number of objects,
      // using sethemingcolor to highlight will not affect performance.
      setThemingColorForDbIds({
        dbIds: highlightDbIds,
        color: params.color,
        opacity: 1,
        storeThemingColor: true,
      });
    },
    [isLoadedViewerModelData]
  );

  return {
    clearHighlightOtherObjects,
    hideOtherObjectsWithExcludeDbIds,
    highlightOtherObjectsWithExcludeDbIds,
  };
};

export default useBehaviorOtherObjects;
